import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useNavigate } from 'react-router-dom';

const usePushNotificationListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (Capacitor.getPlatform() === 'web') return;

    // const handleForegroundNotification = (notification) => {
    //   console.log('Foreground notification received:', notification);
    // };

    const handleNotificationTap = (action) => {
      // console.log('Notification tapped:', action);
      const redirectUrl = action.notification?.data?.redirectUrl;
      if (redirectUrl) {
        navigate(redirectUrl);
      }
    };

    // PushNotifications.addListener('pushNotificationReceived', handleForegroundNotification);
    PushNotifications.addListener('pushNotificationActionPerformed', handleNotificationTap);

    return () => {
      PushNotifications.removeAllListeners();
    };
  }, [navigate]);
};

export default usePushNotificationListener;
